import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FILE_SIGNED_URL_EXPIRES_SEC = 3600;

const PRIVATE_HOSTS = new Set(["localhost", "127.0.0.1", "0.0.0.0", "::1"]);

const pickSignedUrl = (payload) => {
  if (!payload || typeof payload !== "object") return null;
  const url = payload.url
    || payload.signed_url
    || payload.signedUrl
    || payload.preview_url
    || payload.previewUrl
    || payload.data?.url
    || payload.data?.signed_url;
  return typeof url === "string" && url.trim() ? url.trim() : null;
};

/** Microsoft can only fetch HTTPS URLs on the public internet (not localhost / private IPs). */
export const isPublicHttpsFileUrl = (fileUrl) => {
  if (!fileUrl) return false;
  try {
    const parsed = new URL(fileUrl);
    if (parsed.protocol !== "https:") return false;
    const host = parsed.hostname.toLowerCase();
    if (PRIVATE_HOSTS.has(host) || host.endsWith(".local")) return false;
    if (/^(10|127|169\.254)\./.test(host)) return false;
    if (/^192\.168\./.test(host)) return false;
    if (/^172\.(1[6-9]|2\d|3[0-1])\./.test(host)) return false;
    return true;
  } catch {
    return false;
  }
};

/** Office Online Viewer often blocks iframes on http://localhost (CSP frame-ancestors). */
export const canEmbedOfficeViewerInPage = () => (
  typeof window !== "undefined" && window.location?.protocol === "https:"
);

/** Authenticated GET /files/:id/signed-url — public HTTPS URL for Office Online Viewer. */
export const fetchFileSignedUrl = async (
  fileId,
  expires = FILE_SIGNED_URL_EXPIRES_SEC,
) => {
  if (!fileId) return null;
  const res = await axios.get(`${API}/files/${encodeURIComponent(fileId)}/signed-url`, {
    params: { expires },
  });
  return pickSignedUrl(res.data);
};
